module.exports = " <div class=text-display> <div class=row> <label class=\"col-sm-4 control-label\">{{ field.label }}</label> <div class=col-sm-8>{{ field.value }}</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/displays/TextDisplay.vue
// module id = 718
// module chunks = 2